<ng-container *ngIf="!isAnalysisView">
  <div class="card p-4">
    <ng-container *ngIf="hasSubmissions$ | async; else noSubmissions">
      <ng-container *ngIf="submissions$ | async as submissions">
        <ng-container *ngFor="let item of submissions | keyvalue: sortByDateDesc">
          <h4>{{ item.key | date: 'MMMM YYYY':'':'de-DE' }}</h4>

          <div class="row d-flex flex-md-row submission-container">
            <ng-container *ngFor="let submission of item.value; let i = index">
              <div class="col-md-6">
                <div class="survey-list-item" (click)="onSurveyClick(submission)">
                  <img
                    *ngIf="submission.isCompleted"
                    src="../../../../../../assets/images/success-icon.svg"
                    alt="Completed"
                  />
                  <img
                    *ngIf="!submission.isCompleted"
                    src="../../../../../../assets/images/warning-icon.svg"
                    alt="Incomplete"
                  />
                  <div class="survey-list-details">
                    <span class="text-muted">
                      <small>{{ submission.createdAt | date: 'dd.MM.YYYY HH:mm' }}</small>
                    </span>
                    <span>
                      <strong *ngIf="submission.isCompleted">
                        {{ 'monitored_user_submissions.complete' | translate }}
                        <ng-container *ngIf="submission.completedBy">
                          {{
                            'monitored_user_submissions.completed_by'
                              | translate: { name: submission.completedBy }
                          }}
                        </ng-container>
                      </strong>
                      <strong *ngIf="!submission.isCompleted">
                        {{ 'monitored_user_submissions.incomplete' | translate }}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #noSubmissions>
      <div class="col-md-12">
        <span>
          {{ 'monitored_user_submissions.empty' | translate }}
        </span>
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-container *ngIf="isAnalysisView">
  <div class="card p-4">
    <h2>{{ 'monitored_user_submissions.analysis' | translate }}</h2>
    <p>{{ 'monitored_user_submissions.subtitle' | translate }}</p>

    <ng-container *ngIf="vm$ | async as vm">
      <ng-container
        *ngIf="
          vm.bmi &&
          vm.timeSnap?.weight != null &&
          vm.timeSnap?.timestamp &&
          vm.weightChangePercentage != null
        "
      >
        <div class="mt-2 mb-5 container-md card border-0">
          <app-flow-situation-card
            [user]="vm.user"
            [bmi]="vm.bmi"
            [weightChangePercentage]="vm.weightChangePercentage"
            [timeSnap]="vm.timeSnap"
            [scoreDetails]="vm.scoreDetails"
            [latestSubmissionDate]="vm.latestSubmissionDate"
          ></app-flow-situation-card>
        </div>
      </ng-container>
    </ng-container>

    <table class="table">
      <tbody>
        <ng-container *ngIf="submissionDetails$ | async as submissionDetails">
          <ng-container *ngFor="let question of submissionDetails.questions">
            <tr>
              <td class="py-2 question-text">{{ question.question }}</td>
              <td>
                <span
                  class="
                    badge
                    px-3
                    py-2
                    fw-bold
                    rounded
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                  [style.background-color]="
                    (question.answers[0] | colorPipe: question.type).background
                  "
                  [style.color]="(question.answers[0] | colorPipe: question.type).font"
                  [style.border-radius]="'6px'"
                  [style.height]="'30px'"
                >
                  {{
                    question.answers[0]
                      | answerDisplay: question.question:question.type:question.options ?? []
                      | translate
                  }}
                </span>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

    <button class="btn btn-primary mt-4" (click)="switchBackToListView()">
      {{ 'monitored_user_submissions.back' | translate }}
    </button>
  </div>
</ng-container>
